// @ts-check
/* eslint-disable react/prop-types */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import Login from '../Login/Login';
import Forgot from '../Forgot/Forgot';
import Submissions from '../Submissions/Submissions';
import { PrivateRoute } from '../PrivateRoute/PrivateRoute';
import Submission from '../Submission/Submission';
import UserReviews from '../UserReviews/UserReviews';
import { Sidebar } from '../../components/Sidebar/Sidebar';
import { Message } from '../../components/Message/Message';
import { clearMessages, showMessage } from '../../redux/reducers/message';
import { logOut } from '../../redux/reducers/auth';
import './App.scss';

/**
 *
 * @param {object} props
 * @param {object} props.message
 * @param {object} props.clearMessages
 * @param {object} props.auth
 * @param {object} props.logOut
 * @returns
 */
function App(props) {
  const { message, auth, clearMessages, logOut } = props;
  return (
    <div className='mainContainer'>
      <Message msg={message} clear={clearMessages} />
      <Sidebar className='sideBar' auth={auth} logout={logOut} />
      <div className='content'>
        <Route exact path='/' component={Login} />
        <PrivateRoute
          auth={auth}
          exact
          path='/submissions'
          component={Submissions}
        />
        <PrivateRoute
          auth={auth}
          exact
          path='/submissions/:type'
          component={Submissions}
        />
        <PrivateRoute
          auth={auth}
          exact
          path='/submission/:id'
          component={Submission}
        />
        <PrivateRoute
          auth={auth}
          exact
          path='/reviews'
          component={UserReviews}
        />
        <Route auth={auth} exact path='/forgot' component={Forgot} />
      </div>
    </div>
  );
}

const mapStateToProps = ({ message, auth }) => ({
  message,
  auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ showMessage, clearMessages, logOut }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);
